/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from 'angular-tree-component';

/**
 * This is an extension of <code>tree-node</code> component which allows DnD in heteragenous environment.
 */
@Component({
  selector: 'gh-tree-node-dnd',
  template: require('./tree-node-dnd.component.html'),
})
export class TreeNodeDndComponent {
  @Input() node: TreeNode;
  @Input() index: number;
  @Input() templates: any;
}
